import { useEffect } from "react";
import { useMapRadiusStore } from "..";
import IGeoCoordinate from "../interfaces/IGeoCoordinate";

export default function (coordinates: IGeoCoordinate, radius: number, visible: boolean, lock: string): void {
    const mapRadiusStore = useMapRadiusStore();

    useEffect(() => {
        if (visible)
            mapRadiusStore.draw(coordinates, radius, lock);
        else
            mapRadiusStore.clear(lock);

        return () => mapRadiusStore.clear(lock);
    }, [coordinates, radius, visible]);
}